import React, { FunctionComponent, useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Icon, DatePicker, TextArea, Input, Badge, Tooltip, Checkbox, Select } from '@scuf/common';
import { IEmailTargetComponentProps } from './IEmailTargetComponentProps';
import { getProfileDetails } from '../../services/Opportunities';
import { setIsActionAlreadyCompleted } from '../../slices/actionTrackingSlice';
import { ReactComponent as GreenTick } from '../../images/green-tick.svg';
import { ACTION_ALREADY_COMPLETED_TEXT, ACTION_ALREADY_COMPLETED_NOTE } from '../../../src/constants/constants'
import './EmailTargetComponent.scss';


export const EmailTargetComponent: FunctionComponent<IEmailTargetComponentProps> = (props) => {
    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [emailSuggestion, setEmailSuggestion] = useState([] as any);
    const [placeholderemail, setPlaceholderemail] = useState('Type min 3 Characters');
    const [remarkValue, setRemarkValue] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [dateValue, setDateValue] = useState('')
    const [showLableBardge, setShowLableBardge] = useState(false);
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const [messageForReq, setMessageForReq] = useState("");
    const [isActAreadyCompleted, setIsActAreadyCompleted] = useState<boolean>(false)
    const [trainingNameValue, setTrainingNameValue] = useState('');
    const isTrainingRequiredReason = props.actionType === 'acceptanddropdown';
    const dispatch = useDispatch();

    useEffect(() => {
        props.email && setEmailValue(props.email);
        props.remark && setRemarkValue(props.remark);
        props.date && setDateValue(props.date);
        props.trainingName && setTrainingNameValue(props.trainingName);
        props.isRemarkRequired && setShowLableBardge(props.isRemarkRequired);
        if (props.isActionTaken) {
            setIsActAreadyCompleted(true);
            dispatch(setIsActionAlreadyCompleted(true));
        }
        setShowValidationMessage(true);
        setMessageForReq(getRequiredFileds());
        if (props.sameDatePostion?.includes(props.elementPosition) || props.email) {
            setPlaceholderemail("");
        }
    }, [props.email, props.remark, props.date, props.trainingName, props.isRemarkRequired, props.reasonId, props.isActionTaken]);

    const handleTrainingNameChange = (value: string) => {
        setTrainingNameValue(value);
        props.handleModifyDataofArray(value, props.elementPosition, "training_name", (emailValue.length > 0 && dateValue.length > 0 && (remarkValue.length > 0 || props.isRemarkRequired === false)));
    }

    const getRequiredFileds = () => {
        let messageForReqValues = "Please provide ";
        messageForReqValues = emailValue ? messageForReqValues + "" : messageForReqValues + "Email, ";
        messageForReqValues = dateValue ? messageForReqValues + "" : messageForReqValues + "Target Date, ";
        messageForReqValues = props.isRemarkRequired && !remarkValue ? messageForReqValues + "Remark " : messageForReqValues + "";
        messageForReqValues = messageForReqValues + "before adding another record"
        return messageForReqValues;
    }

    const handleDelete = () => {
        props.handleModifyDataofArray("", props.elementPosition, "action_owner_id", false);
        props.handleModifyDataofArray("", props.elementPosition, "action_owner_email", false);
        setPlaceholderemail("Type min 3 Characters");
        setEmailValue("")
    }

    const onAddElement = () => {
        props.onAddElement();
    }

    const onDeleteElement = () => {
        props.onDeleteElement(props.elementPosition);
    }

    const handleSearchSelect = (emailData: any) => {
        setEmailSuggestion([]);
        setPlaceholderemail('')
        setEmailValue(emailData.email);
        props.handleModifyDataofArray(emailData.eid, props.elementPosition, "action_owner_id", (emailData.email && dateValue.length > 0 && remarkValue.length > 0) || (emailData.email.length > 0 && dateValue.length > 0 && props.isRemarkRequired === false))
        props.handleModifyDataofArray(emailData.email, props.elementPosition, "action_owner_email", (emailData.email && dateValue.length > 0 && remarkValue.length > 0) || (emailData.email.length > 0 && dateValue.length > 0 && props.isRemarkRequired === false))
        setValue("")
    };
    const setRemarkHandleChange = (remark: string) => {
        props.handleModifyDataofArray(remark, props.elementPosition, "remarks", (emailValue.length > 0 && dateValue.length > 0 && remark.length > 0) || (emailValue.length > 0 && dateValue.length > 0 && props.isRemarkRequired === false))
        setRemarkValue(remark);
    }
    const handleDate = (date: any) => {
        setDateValue(date.toDateString());
        props.handleModifyDataofArray(date.toDateString(), props.elementPosition, "target_date", (emailValue.length > 0 && date.toDateString().length > 0 && remarkValue.length > 0) || (emailValue.length > 0 && date.toDateString().length && props.isRemarkRequired === false))

    }

    const handleSearchChange = (val: string = '') => {
        setValue(val);
        setError('');
        if (val && val.length >= 3) {
            getProfileDetails(val).then((response: any) => {
                setEmailSuggestion(response);
            });
        } else if (val.length == 0) {
            setEmailSuggestion([]);
        }
    };
    const handleActionAlreadyCompletetedChange = (value: boolean) => {
        dispatch(setIsActionAlreadyCompleted(value));
        setIsActAreadyCompleted(value);
        props.handleModifyDataofArray(value, props.elementPosition, "isActionTaken", (emailValue && dateValue.length > 0 && remarkValue.length > 0) || (emailValue.length > 0 && dateValue.length > 0 && props.isRemarkRequired === false))
        if (value) {
            setDateValue(new Date().toDateString());
            props.handleModifyDataofArray(new Date().toDateString(), props.elementPosition, "target_date", (emailValue.length > 0 && new Date().toDateString().length > 0 && remarkValue.length > 0) || (emailValue.length > 0 && new Date().toDateString().length && props.isRemarkRequired === false))

        } else {
            setDateValue('');
            props.handleModifyDataofArray('', props.elementPosition, "target_date", false);
        }
    }

    return (
        <div className="accept-email">
            {isTrainingRequiredReason && props.trainingOptions && props.trainingOptions.length > 0 && (
                <div className='accept-email-wrapper-training'>
                    <label className="">
                        Training Name
                    </label>
                    <Select
                        data-testid="training-name"
                        className="textbox textbox--enabled"
                        fluid={true}
                        placeholder="Select training"
                        options={props.trainingOptions}
                        value={trainingNameValue}
                        onChange={handleTrainingNameChange}
                    />
                </div>
            )}
            <div className='accept-email-wrapper'>
                <div className='accept-email-wrapper-email'>  <label className="">
                    Email
                </label>
                    <div >
                        <Input
                            className="textbox textbox--enabled"
                            value={value}
                            onChange={handleSearchChange}
                            type="email"
                            placeholder={placeholderemail}
                        />

                        <div>{error && <p className="input-email_error">{error}</p>}</div>
                        <div
                            className={
                                emailSuggestion.length === 0 ? '' : 'input-email_wrapper'
                            }
                        >
                            {value.length >= 3 && emailSuggestion.map((emailData: any) => {
                                return (
                                    <div
                                        className="input-suggestions"
                                        onClick={() => handleSearchSelect(emailData)}
                                        key={emailData.id}
                                    >
                                        <div className="input-suggestions_block">
                                            <span>{emailData.last_name}</span>
                                            <span className="input-suggestions-name">
                                                {emailData.first_name}
                                            </span>
                                        </div>
                                        <div className="input-suggestions_data">
                                            {emailData.email}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        {
                            emailValue.length > 0 ? <div className="email-selected-wrapper">
                                <div className="email-selected" >
                                    <div className="email-selected-email-content">{emailValue}</div>
                                    <div
                                        className="badges_close-email"
                                        onClick={handleDelete}
                                    >
                                        X
                                    </div>
                                    <div className="badges_actioncompleted">{isActAreadyCompleted && <GreenTick />}</div>
                                </div>
                            </div>
                                : null}
                    </div></div>
                {!isActAreadyCompleted ? <div className='accept-email-wrapper-date'>
                    <label className="">
                        Target Date
                    </label>
                    <div>
                        <DatePicker className='date-picker' fluid={true} disablePast={true} onChange={handleDate} value={dateValue} />
                    </div>
                </div> : ''}
                {!props.hideRowControls && (
                    <div className='accept-email-wrapper-add'>
                        {
                            (props.elementPosition === (props.emailRemarkLength - 1)) &&
                                (
                                    (emailValue && dateValue && remarkValue) || (emailValue && dateValue && props.isRemarkRequired === false)
                                ) ?
                                <Icon name="slider-controls-plus" className="add-icon" onClick={onAddElement} size="large" />
                                :
                                ((emailValue && dateValue && remarkValue) || (emailValue && dateValue && props.isRemarkRequired === false)) ?
                                    <Icon name="slider-controls-plus" className="add-icon" size="large" /> : <Tooltip
                                        content={messageForReq}
                                        element={<Icon name="slider-controls-plus" className="add-icon" size="large" />}
                                        position="left center"
                                        event="focus"
                                        hoverable={true}
                                    />
                        }
                    </div>
                )}
                {!props.hideRowControls && (
                    props.emailRemarkLength === 1 ?
                        <Tooltip
                            content="Please uncheck the checkbox to delete this record"
                            element={<Icon className='delete-icon-tooltip' name="delete" />}
                            position="left center"
                            event="focus"
                            hoverable={true}
                        />
                        : <div className='accept-email-wrapper-delete'>
                            <Icon className='delete-icon' name="delete" onClick={onDeleteElement} />
                        </div>
                )}
            </div>
            <Checkbox label={ACTION_ALREADY_COMPLETED_TEXT} className="checkbox-fi" checked={isActAreadyCompleted} onChange={handleActionAlreadyCompletetedChange} />
            <label className="label">
                Remarks{" "}
                {(showLableBardge && remarkValue === "") && (
                    <Badge empty={true} color="red" />
                )}
            </label>
            <TextArea
                onChange={setRemarkHandleChange}
                className="textarea-wrapper textarea-fi accept-gap"
                data-testid='remarks-field'
                fluid={true}
                rows={2}
                value={remarkValue.trimStart()}
            />
        </div>
    )

};
